import { render, staticRenderFns } from "./OrgSunset.vue?vue&type=template&id=64adc98e&scoped=true"
import script from "./OrgSunset.vue?vue&type=script&lang=ts"
export * from "./OrgSunset.vue?vue&type=script&lang=ts"
import style0 from "./OrgSunset.vue?vue&type=style&index=0&id=64adc98e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64adc98e",
  null
  
)

/* custom blocks */
import block0 from "./OrgSunset.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports